import { createContext, Component } from 'react';
import PropTypes from 'prop-types';
import { createBrowserHistory } from 'history';

export const BrowserHistoryContext = createContext({});

export class BrowserHistoryContextProvider extends Component {
    constructor() {
        super();
        this.state = {
            currentState: {},
        };
        this.history = null;
        this.back = this.back.bind(this);
        this.pushState = this.pushState.bind(this);
        this.handlePopState = this.handlePopState.bind(this);
    }

    componentDidMount() {
        this.history = createBrowserHistory();
        this.history.listen(this.handlePopState);
        if (window.location.hash === '#zoomModalOpen') {
            this.history.replace('#', null);
        }
    }

    handlePopState(event) {
        this.setState({
            currentState: event.state,
        });
    }

    pushState(state, location) {
        if (this.history) {
            this.history.push(location, state);
            this.setState({
                currentState: state,
            });
        }
    }

    back() {
        if (this.history) {
            this.history.goBack();
        }
    }

    render() {
        const { children } = this.props;
        return (
            <BrowserHistoryContext.Provider
                value={{
                    back: this.back,
                    pushState: this.pushState,
                    currentState: this.state.currentState || {},
                }}
            >
                {children}
            </BrowserHistoryContext.Provider>
        );
    }
}

BrowserHistoryContextProvider.propTypes = {
    children: PropTypes.node,
};
